import * as actionTypes from "../constants";
import { updateObject } from "../../utils";

const initialState = {
  response: null,
  error: null,
  pin: null,
};

const setError = (state, action) => {
  return updateObject(state, {
    error: action.error,
  });
};

const setResponse = (state, action) => {
  return updateObject(state, {
    response: action.response,
    pin: action.pin,
  });
};

const restore = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.RESTORE_SET_ERROR:
      return setError(state, action);
    case actionTypes.RESTORE_SET_RESPONSE:
      return setResponse(state, action);
    case actionTypes.RESET:
      return initialState;
    default:
      return state;
  }
};

export default restore;
